import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Person = GlassFrogModel.extend({ }, {
  resourceName: 'people',
})

export default Person
